module.exports = __webpack_public_path__ + "assets/lessons/en/lesson2/pages/lesson_2_18.pdf";